// User related
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_IS_IN_TEAMS = 'SET_IS_IN_TEAMS';
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const SET_TOKEN_ERROR = 'SET_TOKEN_ERROR';

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";

export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const FETCH_USERS_FAIL = "FETCH_USERS_FAIL";

// General actions
export const ADD_GENERAL_REQUEST = "ADD_GENERAL_REQUEST";
export const ADD_GENERAL_SUCCESS = "ADD_GENERAL_SUCCESS";
export const ADD_GENERAL_FAILURE = "ADD_GENERAL_FAILURE";

// Portal actions
export const PORTAL_DETAIL_LOADING = "PORTAL_DETAIL_LOADING";
export const PORTAL_DETAIL_SUCCESS = "PORTAL_DETAIL_SUCCESS";
export const PORTAL_DETAIL_ERROR   = "PORTAL_DETAIL_ERROR";

// Sync users
export const SYNC_USERS_LOADING = "SYNC_USERS_LOADING";
export const SYNC_USERS_SUCCESS = "SYNC_USERS_SUCCESS";
export const SYNC_USERS_ERROR   = "SYNC_USERS_ERROR";


